(function () {
  'use strict';

  angular
    .module('traineeWebApp.handout')
    .service('handoutResource', handoutResource);

  handoutResource.$inject = ['$http', 'ServiceHelper'];

  function handoutResource($http, ServiceHelper) {
    var url = {
      handout: 'https://:host/:ipad/gaviota-api/handout/:fileId/download'
    };

    var keys = ['ipad', 'fileId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response.data);
      });
    }

    this.getHandoutDownloadURL = function getHandoutDownloadURL(fileId, resultCb, errorCb) {
      var urlParams = _.extend({fileId: fileId}, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.get(createUrl(url.handout, urlParams)), resultCb, errorCb);
      });
    };
  }

})();
